import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI/_Legacy'

import { Avatar, Card, Container } from './styles'

function CtoSlide({ person }) {
  return (
    <Container>
      <Card mt={[70]}>
        <Avatar
          alt={person.title ? `Photo of ${person.title}` : ''}
          src={person.avatar.src}
        />

        <Text as="h3" fontSize={[16, 16, 20]} mb={5}>
          {person.title}
        </Text>

        <Text fontSize={[14, 14, 14, 16]} light>
          {person.description}
        </Text>
      </Card>
    </Container>
  )
}

CtoSlide.defaultProps = {
  person: {},
}

CtoSlide.propTypes = {
  person: PropTypes.object,
}

export default CtoSlide
